import React from "react";
import { AiOutlineForm } from 'react-icons/ai';

const Apostillas = () => {
    return (
        <div className='pt-10'>
            <div className=" p-6 max-w-2xl mx-auto bg-white rounded-xl shadow-md flex items-center flex-col">            
                <h1 className=' font-bold text-principal text-2xl pb-4 font-sans'>Apostillas</h1>

                <p className='text-xl font-sans text-center'>
                    La Apostilla es certificar la autenticidad de la firma de funcionarios públicos o agentes diplomáticos en ejercicio de sus funciones y la calidad en que hayan actuado, la cual deberá estar registrada en la base de datos del Ministerio de Relaciones Exteriores, para que el documento sea válido y surta efectos legales en otro país miembro del Convenio de La Haya de 1961, sobre la abolición del requisito de legalización para documentos públicos extranjeros.
                </p>

                <a
                    href={`https://wa.me/+573104032213?text=Hola,%20quiero%20solicitar%20información%20sobre%20Apostillas.`} target="_blank" rel="noopener noreferrer"
                    className='text-center bg-principal text-white py-2 px-6 rounded-full border-2 border-principal font-semibold mt-4 hover:bg-white hover:text-principal hover:scale-95 transition-all duration-200 ease-out'>
                    <AiOutlineForm size={25} className='inline-block mr-2' />
                    Solicitar
                </a>

            </div>
        </div>
    );
}

export default Apostillas;